var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-dialog-confirm',{attrs:{"md-active":_vm._showRemoveDialog,"md-title":"確認刪除","md-content":"是否確認刪除此筆資料？","md-confirm-text":"確認","md-cancel-text":"取消"},on:{"update:mdActive":function($event){_vm._showRemoveDialog=$event},"md-cancel":function($event){_vm.$emit('close')},"md-confirm":function($event){_vm.$emit('confirm')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e937de3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/ConfirmRemove.vue
// module id = null
// module chunks = 